<template>
  <div class="media-data">
    <!-- <a-button class="add-btn" type="primary" @click="addClick">新增</a-button> -->
    <a-form class="ant-advanced-search-form" :form="searchParams" v-if="filterVisible" >
      <a-row :gutter="24">
      <a-col :span="6" >
        <a-form-item label="任务名称">
          <a-input v-model="searchParams.name" placeholder="请输入任务名称"></a-input>
        </a-form-item>
      </a-col>
      <a-col :span="6" >
        <a-form-item label="订阅状态">
          <a-select v-model="searchParams.status" placeholder="请选择订阅状态">
            <a-select-option :value="true">
              已订阅
            </a-select-option>
            <a-select-option :value="false">
              未订阅
            </a-select-option>
          </a-select>
        </a-form-item>
      </a-col>
      <a-col :span="6">
        <a-form-item label="分析模型">
          <a-input v-model="searchParams.templateName" placeholder="请输入分析模型"></a-input>
        </a-form-item>
      </a-col>
      <a-col :span="6" >
        <div class="mt-40">
          <a-button type="primary" class="mr-24" @click="search">查询</a-button>
          <a-button @click="reset">重置</a-button>
        </div>
      </a-col>
      </a-row>
    <!-- <a-input-search class="input-search" v-model="searchKeyWord" placeholder="请输入显示名称、字段名称或说明" @search="search" /> -->
    </a-form>
		<div class="page-table">
      <vxe-grid
        border="inner"
        :columns="columns"
        auto-resize
        :column-config="{resizable: true}"
        :row-config="{isCurrent: true, isHover: true}"
        id="id"
        :data="data"
        :empty-render="{name: 'NotData'}"
        show-overflow
        size="small"
        :loading="loading"
      >
        <template #id="{row}">
          <span>{{row.id}}</span>
        </template>
        <template #status="{row}">
          <a-switch v-model="row.status" @change="changeStatus(row)" />
        </template>
        <template #execFrequency="{row}">
          <div class="df-between pr-20">
            <div class="mr-20">
              <span>{{getExecFrequency(row.execFrequency)}}</span>
              <span>{{getExecDate(row.execFrequency, row.execDate)}}</span>
            </div>
            <div >
              <span v-if="row.execFrequency === 'EVERY_HOUR'">{{row.execMinute}}</span>
              <span v-else>{{row.execTime[0]}}</span>
            </div>
          </div>
        </template>
        <template  #receivers="{row}">
          <span>飞书{{ getReceivers(row.receivers).feishuEmailsLen }}个</span> ,
          <span>邮箱{{ getReceivers(row.receivers).emailsLen  }}个</span>
        </template>
       
        <template #logCount="{row}">
          <a-button type="link" @click="handleOpen(row)">{{row.logCount}}</a-button>
          <span style="margin-left: -10px;">
            次
            </span>
        </template>
        <template  #handle="{row}">
					<div class="table-handle-btn">
            <a-tooltip placement="top" title="查看">
              <icon-font @click="handleView(row)" class="view-btn" type="icon-Eye-Open"/>
            </a-tooltip>
            <a-tooltip placement="top" title="编辑">
              <icon-font class="edit-btn" type="icon-Edit" @click="editClick(row)"/>
            </a-tooltip>
            <a-popconfirm
                title="是否确认删除？"
                ok-text="确定"
                cancel-text="取消"
                @confirm="deleteClick(row)"
              >
                <a-tooltip placement="top" title="删除">
                  <icon-font class="delete-btn" type="icon-Delete"/>
                </a-tooltip>
              </a-popconfirm>
          </div>
        </template>
      </vxe-grid>
      <a-pagination
        class="mt-16 mb-16 df-end"
        size="small"
        :pageSize="pagination.pageSize"
        :total="pagination.total"
        :current="pagination.current"
        @change="(page, pageSize) => handleTableChange(page,pageSize)"
      />
    </div>
    <addChartSub ref="addModal" :code="code" @success="pagination.current = 1,getList()"></addChartSub>
    <chartSubTask ref="chartSubTask" :id="currentId"></chartSubTask>
  </div>
</template>
<script>
import { searchChartSubList, delChartSub, updateStatusChartSub } from "@/api/chartSub"
import addChartSub from "./addChartSub"
import chartSubTask from "./chartSubTask"

const columns = [
  {
		title: '订阅任务ID',
		field: 'id',
		align: 'left',
    slots: { default: 'id' },
		// width: 160,
	},
	{
		title: '任务名称',
		field: 'name',
		align: 'left',
    ellipsis: true,
		width: 120,
	},
	{
		title: '订阅状态',
		field: 'status',
		align: 'left',
		slots: { default: 'status' },
		width: 120,
	},
  {
		title: '分析模型',
		field: 'templateName',
		align: 'left',
    ellipsis: true,
		// width: 200,
	},
	{
		title: '订阅时间',
		field: 'execFrequency',
		align: 'left',
    ellipsis: true,
		width: 140,
    
    slots: { default: 'execFrequency' },
	},
  {
    title: '接收人',
    field: 'receivers',
    align: 'left',
    width: 160,
    slots: { default: 'receivers' },
  },
	{
		title: '订阅日志',
		field: 'logCount',
		align: 'left',
    ellipsis: true,
		width: 100,
    slots: { default: 'logCount' },
	},
	{
		title: '更新时间',
		field: 'updateTime',
		align: 'left',
    ellipsis: true,
		// width: 150,
	},
  {
		title: '操作',
		field: 'handle',
		align: 'left',
		slots: { default: 'handle' },
		// width: 120,
	},
]
const initSearchParams = {
  name: undefined,
  status: undefined,
  templateName: undefined,
}
export default {
	name: 'MediaData',
	data() {
		return {
			loading: false,
      searchKeyWord: '',
			pagination: {
				current: 1,
				total: 0,
				pageSize: 10,
        showTotal: total => `共${total}条`
			},
			data: [],
			columns,
      searchParams: this.$deepclone(initSearchParams),
      currentId: null,
		}
	},
  props: ['code', 'filterVisible'],
  methods: {
    reset(){
      this.searchParams = this.$deepclone(initSearchParams);
      this.pagination.current = 1;
      this.getList();
    },
    handleOpen(record){
      this.currentId = record.id;
      this.$refs.chartSubTask.visible = true;
    },
    getExecFrequency(val){
      return this.$enum.FrequencyList.find(item => item.value === val)?.name || '';
    },
    getExecDate(val, date){
      let name = ''
      if(val === 'EVERY_WEEK'){
        name = this.$enum.WeekList.find(item => item.value === date)?.name || '';
      }else if(val === 'EVERY_MONTH'){
        name = this.$enum.GetMonthList().find(item => item.value === date)?.name || '';
      }
      return name;
    },
    changeStatus(record){
      const params = {id : record.id, status: record.status}
      updateStatusChartSub(params).then((res) => {
				this.$message.success('更改成功！')
				if(this.data.length === 1) {
					this.pagination.current = 1
				}
				this.getList()
      })
    },
    getReceivers(row){
      const receivers = row;
      const {emails, feishuEmails } = receivers;
      let emailsLen = 0, feishuEmailsLen = 0;
      if(emails){
        emailsLen = emails.split(',').length;
      } 
      if(feishuEmails){
        feishuEmailsLen = feishuEmails.split(',').length;
      }
      return {
        emailsLen,
        feishuEmailsLen
      }
    },
    addClick() {
      this.$refs.addModal.init(false)
    },
    editClick(record) {
      this.$refs.addModal.init(false, record)
    },
    handleView(record) {
      this.$refs.addModal.init(true, record)
    },
    search() {
      this.pagination.current = 1
      this.getList()
    },
    getList() {
      this.loading = true
      const params = {
          pageSize: this.pagination.pageSize,
          pageNo: this.pagination.current,
          ...this.searchParams
        }
      searchChartSubList(params).then((res) => {
        this.data = res.data.recordList || []
        this.pagination.total = res.data.recordCount
      }).finally(() => this.loading = false)
    },
    
    handleTableChange(page) {
			console.log(page);
			let pager = { ...this.pagination, current:page };
			 
			this.pagination = pager;
			this.getList()
		},
    // 删除
		deleteClick(record) {
      const params = {id : record.id}
      delChartSub(params).then((res) => {
				this.$message.success('删除成功！')
				if(this.data.length === 1) {
					this.pagination.current = 1
				}
				this.getList()
      })
		}
  },
  mounted() {
    this.getList()
  },
  components: {
    addChartSub,
    chartSubTask
  }
}
</script>
<style lang="less" scoped>
.media-data {
  position: relative;
  .frequency-prompt {
		padding-left: 20px;
		padding-bottom: 10px;
	}
  .input-search {
    width: 258px;
    top: -53px;
    position: absolute;
    right: 24px;
  }
  .add-btn {
    position: absolute;
    top: -53px;
    right: 302px;
  }
  .edit-btn {
		margin-right: 10px;
	}
	.delete-btn,.copy-btn,.view-btn, .edit-btn {
		cursor: pointer;
		font-size: 16px;
		vertical-align: middle;
	}
  .define-tag {
    color: #2A6CED;
    margin-left: 0px;
    margin-top: -3px;
    transform: scale(0.7, 0.7);
    vertical-align: top;
  }
}
	.view-btn {
		margin-right: 10px;
	}
.ant-advanced-search-form {
  margin: 12px 24px 16px 24px;
  padding: 14px 16px 0 16px;
  background: #FBFCFF;
  // border: 1px solid #d9d9d9;
  border-radius: 8px;
}

.ant-advanced-search-form .ant-form-item {
  // display: flex;
}

.ant-advanced-search-form .ant-form-item-control-wrapper {
  // flex: 1;
}

</style>